(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-section-explore/assets/javascripts/casino-section-explore.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-section-explore/assets/javascripts/casino-section-explore.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo,
  useState = _React.useState,
  useCallback = _React.useCallback;
const GridDisplayModes = svs.components.casino_react.common.constants.GridDisplayModes;
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem;
const CasinoGrid = svs.components.casino_react.CasinoGrid;
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  ButtonGroup = _svs$ui.ReactButtonGroup;
const _svs$casino_react$sha = svs.casino_react.shared.data,
  cmsCategoryList = _svs$casino_react$sha.cmsCategoryList,
  cmsLiveCategoryList = _svs$casino_react$sha.cmsLiveCategoryList,
  cmsProviderList = _svs$casino_react$sha.cmsProviderList,
  cmsGameList = _svs$casino_react$sha.cmsGameList,
  brand = _svs$casino_react$sha.brand;
const QuickSearchPills = svs.components.casino_react.quickSearchPills.QuickSearchPills;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM;
const useSetSearchParams = svs.components.casino_react.hooks.useSetSearchParams;
const TABS = {
  POPULAR: 'popular',
  CATEGORIES: 'categories',
  LIVE_CATEGORIES: 'liveCategories',
  PROVIDERS: 'providers'
};
const fallbackPlayList = {
  list: [],
  displayMode: GridDisplayModes.GRID_UNRESTRICTED
};
const CasinoSectionExplore = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const tabFromUrl = urlParams.get('tab');
  const tabExistsOnTabs = Object.values(TABS).includes(tabFromUrl) ? tabFromUrl : TABS.POPULAR;
  const _useSetSearchParams = useSetSearchParams(),
    setTab = _useSetSearchParams.setTab;
  const _useState = useState(tabExistsOnTabs),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  const isLargeScreen = useMediaQuery(breakpoints.up(BREAKPOINT_AM));
  const activeList = useMemo(() => {
    switch (activeTab) {
      case TABS.CATEGORIES:
        return {
          list: cmsCategoryList,
          displayMode: GridDisplayModes.GRID_UNRESTRICTED
        } || fallbackPlayList;
      case TABS.LIVE_CATEGORIES:
        return {
          list: cmsLiveCategoryList,
          displayMode: GridDisplayModes.GRID_UNRESTRICTED
        } || fallbackPlayList;
      case TABS.PROVIDERS:
        return {
          list: cmsProviderList,
          displayMode: GridDisplayModes.GRID_UNRESTRICTED
        } || fallbackPlayList;
      case TABS.POPULAR:
      default:
        return {
          list: cmsGameList,
          displayMode: GridDisplayModes.GRID_RESTRICTED_DOUBLE_ROW
        } || fallbackPlayList;
    }
  }, [activeTab]);
  const handleTabChange = useCallback(tab => {
    setActiveTab(tab);
    setTab(tab);
  }, [setTab]);
  const renderedContent = useMemo(() => {
    if (!activeList.list.length) {
      handleTabChange(TABS.POPULAR);
    }
    return React.createElement(CasinoGrid, {
      displayMode: activeList.displayMode,
      items: activeList.list
    });
  }, [activeList, handleTabChange]);
  const showCategoryButtons = activeTab === TABS.CATEGORIES || activeTab === TABS.LIVE_CATEGORIES;
  return React.createElement("div", {
    className: "casino-section-explore"
  }, React.createElement("div", {
    className: "casino-section-explore__heading f-content"
  }, React.createElement("h2", null, "Utforska")), React.createElement(ItemsMenu, {
    branding: brand,
    centered: isLargeScreen,
    className: "casino-section-explore__navigation",
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  }, React.createElement(LinkItem, {
    Component: "button",
    label: "Popul\xE4rt",
    onClick: () => handleTabChange(TABS.POPULAR),
    selected: activeTab === TABS.POPULAR
  }), React.createElement(LinkItem, {
    className: "casino-section-explore__item-category",
    Component: "button",
    label: "Kategorier",
    onClick: () => handleTabChange(TABS.CATEGORIES),
    selected: activeTab === TABS.CATEGORIES || activeTab === TABS.LIVE_CATEGORIES
  }), React.createElement(LinkItem, {
    Component: "button",
    label: "Leverant\xF6r",
    onClick: () => handleTabChange(TABS.PROVIDERS),
    selected: activeTab === TABS.PROVIDERS
  })), showCategoryButtons && React.createElement("div", {
    className: "casino-section-explore__category-buttons col-xs-12 col-md-6"
  }, React.createElement(ButtonGroup, {
    block: true
  }, React.createElement(Button, {
    className: "col-xs-6",
    inverted: activeTab === TABS.CATEGORIES,
    onClick: () => handleTabChange(TABS.CATEGORIES),
    size: 300,
    transparent: activeTab !== TABS.CATEGORIES
  }, "Casino"), React.createElement(Button, {
    className: "col-xs-6",
    inverted: activeTab === TABS.LIVE_CATEGORIES,
    onClick: () => handleTabChange(TABS.LIVE_CATEGORIES),
    size: 300,
    transparent: activeTab !== TABS.LIVE_CATEGORIES
  }, "Live Casino"))), React.createElement("div", {
    className: "casino-section-explore__content"
  }, activeTab === TABS.POPULAR && React.createElement(QuickSearchPills, null), renderedContent));
};
setGlobal('svs.components.casino_react.CasinoSectionExplore', CasinoSectionExplore);

 })(window);